<template>
  <ThemeECommerceContainerSection
    event-name=""
    category-event-name=""
    expand
    content-class="!tw-mt-0"
  >
    <DisplayHTMLContent
      v-for="item in modelValue.content"
      :key="`extra-info-${item._id}`"
      :model-value="item.description"
      class="tw-text-mb-body lg:tw-text-dt-body tw-text-dark-gray"
    />
  </ThemeECommerceContainerSection>
</template>

<script lang="ts" setup>
defineProps({
  modelValue: {
    type: Object as PropType<HomeSection<ExtraInfo[]>>,
    required: true,
  },
})
</script>
